import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { environment } from '../../environments/environment';
import { PlatformIdmCanActivate } from '@platform-idm/sdk-angular'
 
export const oktaIdmCanActivate = (route: any, state: any) => {
    return PlatformIdmCanActivate(route, state);  
};



